import { render, staticRenderFns } from "./MatchTabs.vue?vue&type=template&id=8907c644&scoped=true&"
import script from "./MatchTabs.vue?vue&type=script&lang=js&"
export * from "./MatchTabs.vue?vue&type=script&lang=js&"
import style0 from "./MatchTabs.vue?vue&type=style&index=0&id=8907c644&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8907c644",
  null
  
)

export default component.exports